// removed by extract-text-webpack-plugin
module.exports = {"pgd-report-remarks-modal":"pgd-report-remarks-modal","ant-modal-body":"ant-modal-body","save-remarks-btn":"save-remarks-btn","remarks-formitem":"remarks-formitem","ant-form-item-label":"ant-form-item-label","remarks-input":"remarks-input"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/normal/RemarkModal/remarkModal.scss
// module id = 921
// module chunks = 0